module.exports = __webpack_public_path__ + "img/zain-brand.09553095.png";